import maAccordion from '@/components/accordion'
import maInputSurface from '@/components/input/modules/text'
import maButtonWhite from '@/components/button-blue'
import maPhotoclaimGallery from '@/components/photoclaimGallery'
import maDamagedPart from './../damagedPart'
import { required, minValue } from 'vuelidate/lib/validators'
import maEventBus from '@/components/eventbus/index.js'

export default {
  mame: 'damagedPiece',
  data() {
    return {
      inputSurfaceValue: this.damagedPiece.pieceSurface,
      inputTextNumberError: true
    }
  },

  validations: {
    inputSurfaceValue: {
      required,
      minValue: minValue(1)
    }
  },

  props: {
    damagedLiteral: {
      type: String,
      required: true
    },
    damagedKey: {
      type: String,
      required: true
    },
    damagedSurface: {
      type: [Number, String],
      required: true
    },
    damagedPiece: {
      type: Object,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true,
      default: false
    },
    isPhotoclaimFlow: {
      type: Boolean,
      default: false
    },
    photosTaken: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    surfaceInputIsValid() {
      return !this.$v.inputSurfaceValue.$error && this.inputSurfaceValue > 0
    },
    hasDamages() {
      return !!this.damagedPiece.damagedParts.find(
        (damagedPart) =>
          damagedPart.partDamages && damagedPart.partDamages.length > 0
      )
    },
    pieceTitle() {
      const partial = `${this.damagedLiteral} ${this.damagedPiece.pieceId}`
      const full = `${partial} - ${this.damagedPiece.pieceSurface} m2`

      return this.photosTaken ? full : partial
    }
  },

  components: {
    maAccordion,
    maInputSurface,
    maButtonWhite,
    maDamagedPart,
    maPhotoclaimGallery
  },

  methods: {
    /**
     * Using the vulidate library, evaluates if there is an error in the inpus surface value and if so it will set the inputTextNumberError to true and scroll to the top of the page
     *
     */
    inputSurfaceValidation() {
      let validated = false
      this.$v.$touch()
      if (this.$v.inputSurfaceValue.$error) {
        maEventBus.$emit('inputTextNumbers:error')
        this.inputTextNumberError = true
        setTimeout(() => {
          this.inputTextNumberError = false
        }, 2000)
      } else {
        validated = true
      }
      return validated
    },

    handleOnPhotoclaimDamagesConfirmed(damagedPiece, damagedPart) {
      this.$emit('confirmPhotoclaimDamages', damagedPiece, damagedPart)
    },

    handleOnPhotoclaimDamagesEdit(
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    ) {
      this.$emit('edit:photoclaimDamage', {
        damagedPiece,
        damagedKey,
        damagePart,
        damageIndex
      })
    },

    handleOnPhotoclaimDamagesDelete(
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    ) {
      this.$emit('delete:photoclaimDamage', {
        damagedPiece,
        damagedKey,
        damagePart,
        damageIndex
      })
    },

    handleOnChangeSurfaceInput(value) {
      if (this.inputSurfaceValidation()) {
        this.$emit('surfaceChanged', value)
      } else {
        this.$emit('surfaceChanged', 0)
      }
    },

    deletePart(damagePart) {
      this.$emit('deletePart', damagePart)
    }
  },
  watch: {
    damagedSurface() {
      this.inputSurfaceValue = this.damagedSurface
    }
  }
}
